<template>
  <div class="section__subsection_blue section__company-nav">
    <div class="section__subsection-wrapper">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentNavWrapper"
}
</script>

<style scoped>

</style>